module.exports = __webpack_public_path__ + "static/media/calendar-minus.12f96f21.svg";